import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getDb } from "../../../util/Constants";
import { collection, addDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import { Row, Col } from "reactstrap";

export default function AddMiniGame9Modal({ isOpen, toggle, onQuestionAdded }) {
  const [question, setQuestion] = useState("");
  const [mcqs, setMcqs] = useState([]);
  const [answer, setAnswer] = useState("");
  const [title, setTitle] = useState("");
  const [chartType, setChartType] = useState("verticalbar");
  const [xaxis, setXaxis] = useState([]);
  const [yaxis, setYaxis] = useState([]);
  const [loading, setLoading] = useState(false);

  const resetFields = () => {
    setQuestion("");
    setMcqs([]);
    setAnswer("");
    setTitle("");
    setChartType("verticalbar");
    setXaxis([]);
    setYaxis([]);
  };

  const handleSubmit = async () => {
    if (
      !question.trim() ||
      !answer.trim() ||
      !title.trim() ||
      !chartType ||
      mcqs.length === 0 ||
      xaxis.length === 0 ||
      yaxis.length === 0
    ) {
      Swal.fire("Error", "Please fill all fields.", "error");
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 9",
        question: question.trim(),
        mcqs,
        answer: answer.trim(),
        title: title.trim(),
        chartType,
        xaxis: xaxis.filter((v) => v !== ""),
        yaxis: yaxis.filter((v) => v !== ""),
      });
      Swal.fire("Success", "Question added!", "success");
      resetFields();
      toggle();
      if (onQuestionAdded) onQuestionAdded();
    } catch (error) {
      Swal.fire("Error", "Failed to add question.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>Add MiniGame 9 Question</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Question</Label>
              <Input
                type="textarea"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                rows={2}
                placeholder="Enter question"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Chart Type</Label>
              <Input
                type="select"
                value={chartType}
                onChange={(e) => setChartType(e.target.value)}
              >
                <option value="verticalbar">Vertical Bar</option>
                <option value="horizontalbar">Horizontal Bar</option>
                <option value="pie">Pie</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Answer</Label>
              <Input
                type="text"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                placeholder="Enter correct answer"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Title</Label>
              <Input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter chart title"
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label>MCQ Options (one per line)</Label>
          <Input
            type="textarea"
            value={mcqs.join("\n")}
            onChange={(e) => setMcqs(e.target.value.split("\n"))}
            rows={2}
            placeholder="Enter options, one per line"
          />
        </FormGroup>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>
                X Axis (one per line)
                <span style={{ fontWeight: 400, fontSize: 12, color: "#888" }}>
                  {chartType === "horizontalbar" ? " (numbers)" : " (strings)"}
                </span>
              </Label>
              <Input
                type="textarea"
                value={xaxis.join("\n")}
                onChange={(e) => {
                  if (chartType === "horizontalbar") {
                    const nums = e.target.value
                      .split("\n")
                      .map((v) => v.trim())
                      .map((v) => (v === "" ? "" : Number(v)));
                    setXaxis(nums);
                  } else {
                    setXaxis(e.target.value.split("\n"));
                  }
                }}
                rows={2}
                placeholder={
                  chartType === "horizontalbar"
                    ? "e.g. 110\n170\n180"
                    : "e.g. Jan\nFeb\nMar"
                }
                style={{ marginTop: "22px", minHeight: "100px" }}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>
                Y Axis (one per line)
                <span style={{ fontWeight: 400, fontSize: 12, color: "#888" }}>
                  {chartType === "horizontalbar" ? " (strings)" : " (numbers)"}
                </span>
              </Label>
              <Input
                type="textarea"
                value={yaxis.join("\n")}
                onChange={(e) => {
                  if (chartType !== "horizontalbar") {
                    const nums = e.target.value
                      .split("\n")
                      .map((v) => v.trim())
                      .map((v) => (v === "" ? "" : Number(v)));
                    setYaxis(nums);
                  } else {
                    setYaxis(e.target.value.split("\n"));
                  }
                }}
                rows={2}
                placeholder={
                  chartType === "horizontalbar"
                    ? "e.g. Jan\nFeb\nMar"
                    : "e.g. 110\n170\n180"
                }
                style={{ minHeight: "100px", marginTop: "22px" }}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
